module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_3016.d2395922.png";